import { gql } from '@apollo/client';

export const approveIdentityValidation = gql`
  mutation approveIdentityValidation(
    $identityValidationId: String!
    $identityDocumentType: DNI!
    $identityDocumentCode: String!
    $identityDocumentIssueDate: Float
  ) {
    approveIdentityValidation(
      identityValidationId: $identityValidationId
      identityDocumentType: $identityDocumentType
      identityDocumentCode: $identityDocumentCode
      identityDocumentIssueDate: $identityDocumentIssueDate
    ) {
      value
    }
  }
`;
